import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'wx-edit-icon',
  templateUrl: './edit-icon.component.html',
  styleUrls: ['./edit-icon.component.scss']
})
export class EditIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }



}
